// Lightweight Service Worker registration + helper for prefetching image URLs.
// Nothing crashes if the browser (or Capacitor WebView) doesn't support SW —
// images still load the normal way.
import { Capacitor } from "@capacitor/core";
import { prefetchImages } from "./nativeImageCache";

let regPromise = null;

export function registerSW() {
  if (regPromise) return regPromise;
  if (typeof navigator === "undefined" || !navigator.serviceWorker) {
    return (regPromise = Promise.resolve(null));
  }
  regPromise = navigator.serviceWorker.register("/sw.js", { scope: "/" })
    .then(reg => reg.active ? reg : new Promise(res => {
      const sw = reg.installing || reg.waiting;
      if (!sw) return res(reg);
      sw.addEventListener("statechange", () => sw.state === "activated" && res(reg));
    }))
    .catch(() => null);
  return regPromise;
}

export async function precacheMedia(urls = []) {
  const clean = urls.filter(u => typeof u === "string" && (u.startsWith("http") || u.startsWith("/api/media/")));
  if (!clean.length) return;
  if (Capacitor.isNativePlatform()) return prefetchImages(clean);
  await registerSW();
  const ctrl = navigator.serviceWorker?.controller;
  if (ctrl) ctrl.postMessage({ type: "PRECACHE_URLS", urls: clean });
}

// Collect every media URL from a shop bundle so we can warm the SW cache
// in one shot the moment a shop opens.
export function collectBundleMedia(bundle) {
  const out = [];
  const push = (v) => { if (typeof v === "string" && v) out.push(v); };
  for (const p of bundle?.products || []) {
    push(p.image);
    (p.images || []).forEach(push);
  }
  for (const p of bundle?.posts || []) {
    push(p.image);
    (p.images || []).forEach(push);
  }
  for (const s of bundle?.sections || []) push(s.image);
  const shop = bundle?.shop || {};
  push(shop.logo); push(shop.cover_image); push(shop.hero_image);
  return out;
}
